import { MarketingLayout } from "../components/marketing-layout";
import { HeroSection } from "../components/marketing-layout/HeroSection";
import { VideoSection } from "../components/marketing-layout/VideoSection";
import { SeasonalUseSection } from "../components/marketing-layout/SeasonalUseSection";
import { GetStartedStepsSection } from "../components/marketing-layout/GetStartedStepsSection";
import { FieldCoverageSection } from "../components/marketing-layout/FieldCoverageSection";
import { PricingSection } from "../components/marketing-layout/PricingSection";
import { PartnersSection } from "../components/marketing-layout/PartnersSection";
import { InlineContactSection } from "../components/marketing-layout/InlineContactSection";
import { TestimonialsSection } from "../components/marketing-layout/TestimonialsSection";
import { PageLoadSpinner } from "../components/marketing-layout/PageLoadSpinner";

export const MarketingHomePage = (): JSX.Element => (
	<MarketingLayout>
		<>
			<PageLoadSpinner />
			<HeroSection />
			<SeasonalUseSection />
			<VideoSection />
			<GetStartedStepsSection />
			<PricingSection />
			<PartnersSection />
			<FieldCoverageSection />
			<InlineContactSection />
			<TestimonialsSection />
		</>
	</MarketingLayout>
);
